/* global femcare, autosizeInput */

femcare.ageVerification.verification = {
    init: function() {
        var $ageVerificationModal = $('.age-verification');

        if ($ageVerificationModal.length) {
            $ageVerificationModal.modal({
                backdrop: 'static',
                keyboard: false
            });

           autosizeInput(document.querySelector('#ageVerificationForm input'));

            var ageLimit = $ageVerificationModal.data('age-limit');
            var redirectUrl = $ageVerificationModal.data('redirect-url') || '/';

            $('#ageVerificationForm').on('submit', function(e) {
                e.preventDefault();
                var age = $(this)
                    .find('input[name="age"]')
                    .val();

                if (age >= ageLimit) {
                    $ageVerificationModal.modal('hide');
                } else {
                    window.location.href = redirectUrl;
                }
            });
        }
    }
};
